import {useMutation} from "@tanstack/react-query";

import {restoreRepresentativeMutationOptions} from "./restore-representative.mutation-options";

export function useRestoreRepresentative() {
  return useMutation(restoreRepresentativeMutationOptions());
}
